import { render } from "./prescription.vue?vue&type=template&id=0210f72a&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"

import "./prescription.vue?vue&type=style&index=0&id=0210f72a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0210f72a"]])

export default __exports__